module.exports = __webpack_public_path__ + "img/wodegerenxinxiW.144f6501.png";